import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { enableProdMode } from '@angular/core';
import { loadTranslationsOnBootstrap } from '@lx/shared/app-init';
import { environment } from './environments/environment';
import { getAppConfig } from './app/app.config';
import { resolveLocale, resolveRtlEnabled, saveLocaleToStorage, setDocumentDirection } from './app/utils';
import { COMPANY_STORAGE_KEY, QtLiteEnvironment, STORE_RESET_KEY } from './app/types';
import { handleCompanyChange, resolveCompany, saveCompanyToStorage } from '@lx/quote-tool/lite/shared/utils';

if (environment.production) {
  enableProdMode();
}

// Create runtime environment without mutating the imported environment object
const runtimeEnvironment: QtLiteEnvironment = {
  ...environment,
  LOCALE: resolveLocale(environment.LOCALE),
  COMPANY: resolveCompany(environment.COMPANY, COMPANY_STORAGE_KEY, environment.SUPPORTED_COMPANIES),
};

// Check if company has changed and flag for store reset if needed
handleCompanyChange(runtimeEnvironment.COMPANY, COMPANY_STORAGE_KEY, STORE_RESET_KEY);

loadTranslationsOnBootstrap(runtimeEnvironment, () => {
  // loadTranslationsOnBootstrap falls back to DEFAULT_LOCALE on fetch errors, mutating runtimeEnvironment.LOCALE.
  // By the time this callback runs, runtimeEnvironment.LOCALE holds the definitive locale (original or fallback).
  // Compute RTL using the final locale and pass a new environment object to bootstrapApplication so that
  // dir and RTL_ENABLED remain consistent without further mutating runtimeEnvironment.
  const rtlEnabled = resolveRtlEnabled(runtimeEnvironment.LOCALE, environment.RTL_LOCALES);
  setDocumentDirection(rtlEnabled);
  const finalEnvironment: QtLiteEnvironment = { ...runtimeEnvironment, RTL_ENABLED: rtlEnabled };
  bootstrapApplication(AppComponent, getAppConfig(finalEnvironment)).catch((err) => console.error(err));
}).finally(() => {
  // Store the definitive locale (original or fallback) and company in sessionStorage to persist them across page reloads
  saveLocaleToStorage(runtimeEnvironment.LOCALE);
  saveCompanyToStorage(runtimeEnvironment.COMPANY, COMPANY_STORAGE_KEY);
});
